import React from "react";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";

// BC Wildfire Service fires — crimson flame, distinct from WildCAD (orange)
// and DNR (green). Status colors follow BCWS conventions.
const STATUS_COLORS = {
  "Out of Control": "#E63946",
  "Being Held": "#FFB347",
  "Under Control": "#2A9D8F",
  New: "#F2542D",
};

const _cache = {};
function bcIcon(status) {
  const color = STATUS_COLORS[status] || "#C1121F";
  if (!_cache[status]) {
    _cache[status] = L.divIcon({
      className: "flame-marker",
      html: `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" style="filter: drop-shadow(0 1px 2px rgba(0,0,0,0.6));">
        <path d="M12 1.5c1.8 3.2.6 5-.9 6.7-1.3 1.5-2.6 3-2.1 5.4-1.3-.9-2.2-2.3-2.4-3.9-1.6 1.9-2.6 4.1-2.6 6 0 4 3.6 6.8 8 6.8s8-2.8 8-6.8c0-4.5-4.1-6.3-4.1-10.2-1.2.8-2 2-2.2 3.4C12.6 6.6 11 4.4 12 1.5z"
          fill="#C1121F" stroke="#0A0D0C" stroke-width="1.1" stroke-linejoin="round"/>
        <circle cx="18.5" cy="5.5" r="4.4" fill="${color}" stroke="#0A0D0C" stroke-width="1"/>
        <text x="18.5" y="7.6" font-size="6.2" font-weight="900" text-anchor="middle" fill="#0A0D0C" font-family="sans-serif">BC</text>
      </svg>`,
      iconSize: [26, 26],
      iconAnchor: [13, 22],
      popupAnchor: [0, -18],
    });
  }
  return _cache[status];
}

function fmt(n) {
  if (n == null) return "—";
  return n >= 1000 ? `${(n / 1000).toFixed(1)}k` : `${n}`;
}

export default function BcFiresLayer({ fires = [] }) {
  return (
    <>
      {fires
        .filter((f) => f.latitude != null && f.longitude != null)
        .map((f) => (
          <Marker key={f.id} position={[f.latitude, f.longitude]} icon={bcIcon(f.status)}>
            <Popup>
              <div style={{ minWidth: 200 }} data-testid={`bc-fire-popup-${f.id}`}>
                <div style={{ fontSize: 10, fontWeight: 700, color: "#C1121F", textTransform: "uppercase", letterSpacing: "0.06em" }}>
                  BC Wildfire Service{f.fire_of_note ? " · FIRE OF NOTE" : ""}
                </div>
                <div style={{ fontWeight: 700, fontSize: 14, margin: "3px 0" }}>
                  {f.name} <span style={{ opacity: 0.6, fontWeight: 400 }}>({f.fire_number})</span>
                </div>
                <div style={{ fontSize: 12, lineHeight: 1.6 }}>
                  Status: <b style={{ color: STATUS_COLORS[f.status] || "#C1121F" }}>{f.status}</b>
                  <br />
                  Size: <b>{fmt(f.size_ha)} ha</b> ({fmt(f.size_acres)} ac)
                  {f.cause && <><br />Cause: {f.cause}</>}
                  {f.ignited_at && <><br />Ignited: {new Date(f.ignited_at).toLocaleDateString()}</>}
                </div>
                {f.url && (
                  <a href={f.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: 11, color: "#F2542D" }}>
                    BCWS incident page →
                  </a>
                )}
              </div>
            </Popup>
          </Marker>
        ))}
    </>
  );
}
